import React, {useState, useEffect, useRef} from 'react'

import {
    useHistory
} from 'react-router-dom'

import { 
    Auth 
} from 'aws-amplify'

import {
    Div 
} from '../../Styles/BaseStyles'

import {
    SettingsButton,
} from '../../Styles/Components/DropdownButtonStyles'

import DropdownMenu from './DropdownMenu'

import { useDispatch } from "react-redux"

import { reset as userSliceReset } from '../../Redux/Slices/UserSlice'
import { hubError } from '../../Redux/Slices/HubSlice'

function DropdownButton(props){
    const node = useRef()
    const [open, setOpen] = useState(false)

    let history = useHistory()

    const dispatch = useDispatch()

    var ddbutton = (
        <>
        </>
    )

    var items = []

    const handleClick = e => {
        if (node.current.contains(e.target)) {
            return
        }
        setOpen(false)
    }
    
    useEffect(() => {
        document.addEventListener("mousedown", handleClick)

        return () => {
            document.removeEventListener("mousedown", handleClick);
        }
    }, [])

    switch(props.ddButtonName){
        case "settings":
            function settingsTransition(){
                history.push('/settings')
            }
            function logout(){
                signout()
            }
            items = [{'item_name': "Settings", 'onClick': settingsTransition}, {'item_name': "Log Out", 'onClick': logout, 'color': "red"}]
            ddbutton = (
                <Div ref={node} id="settings-dropdown-div">
                    <SettingsButton onClick={() => setOpen(!open)}>
                        {open && <DropdownMenu items={items} />}
                    </SettingsButton>
                </Div>
            )
            break
        default:
            break
    }

    async function signout() {//look into how to use hooks in Globally used functions
        try {
            await Auth.signOut()
            sessionStorage.clear()
            localStorage.clear()
            history.push('/logoutconfirmation')
        } catch (error) {
            dispatch(hubError({errorPhrase: 'Error Signing Out: ' + error.message}))
        }
    }

    return (
        <>
            {ddbutton}
        </>
    )
}

export default DropdownButton